import OpsText from "../ops-library/ops-text";
import OpsBtn from "../ops-library/ops-btn";
import {useNavigate} from "react-router-dom";

export const SectionHeader = ({title, url, className}) => {
    const navigate = useNavigate()

    return (
        <div
            className={`desktop-row-phone-col fa-w-100 justify-content-between ${className}`}>
            <OpsText type="title8 px-1" weight={800} color="color-1"
                     content={title}/>
            {url !== undefined &&
                <OpsBtn
                    text="Zobraziť viac"
                    variant="text-underline"
                    backgroundColor="bg-transparent"
                    textColor="color-1"
                    action={() => navigate(`/${url}`)}
                />
            }
        </div>
    )
}